import { BUILD, fmtBuildTime } from "@/config/build";

export function AppFooter() {
  return (
    <footer
      data-testid="app-footer"
      className="mt-10 flex flex-col gap-1.5 border-t bg-white px-4 pb-20 pt-4 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between sm:px-6 md:pb-4 lg:px-8"
    >
      <span data-testid="app-build-info">
        Build {BUILD.number} <span className="text-slate-400">(v{BUILD.major}.{BUILD.minor})</span> · Published {fmtBuildTime(BUILD.publishedAt)}
      </span>
      <span data-testid="app-copyright">Copyright © SusTek Pte Ltd. All Rights Reserved.</span>
    </footer>
  );
}
